import axios from 'axios';
import { useFormik } from 'formik';
// import Joi, { object } from 'joi';
import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { string, ref, object } from 'yup';


export default function Register() {
  // let navigate = useNavigate();
  // const [errorMessage, setErrorMessage] = useState('')
  // const [errorsList, setErrorsList] = useState([])
  // const [isLoading, setIsLoading] = useState(false)
  // const [userData, setUserData] = useState({
  //   'name': '',
  //   'age': '',
  //   'email': '',
  //   'password': '',
  // })

  // function getInputValue(e) {
  //   let myUser = { ...userData }
  //   myUser[e.target.name] = e.target.value;
  //   setUserData(myUser);
  // };
  // // console.log(userData);
  // async function sendUserDataToApi() {
  //   let { data } = await axios.post(`https://route-ecommerce-app.vercel.app/api/v1/auth/signup`, userData)
  //   if (data.message === "success") {
  //     setIsLoading(false);
  //     navToLogin()
  //   } else {
  //     setIsLoading(false);
  //     setErrorMessage(data.message)
  //     console.log(errorMessage);
  //   }
  // }

  // function submitFormData(e) {
  //   e.preventDefault(); //to prevent reload on submit
  //   setIsLoading(true);
  //   let validationResult = validateFormData();
  //   if (validationResult.error) {
  //     setIsLoading(false);
  //     setErrorsList(validationResult.error.details);
  //   } else {
  //     sendUserDataToApi();
  //   }
  // };

  // function validateFormData() {
  //   let schema = Joi.object({
  //     name: Joi.string().min(3).max(15).required(),
  //     age: Joi.number().min(16).max(80).required(),
  //     email: Joi.string().email({ minDomainSegments: 2, tlds: { allow: ['com', 'net'] } }).required(),
  //     password: Joi.string().pattern(new RegExp(/^[A-Z][a-z]{3,6}/)),
  //   });
  //   return schema.validate(userData, { abortEarly: false });
  // }
  // // password: Joi.string().regex('/(?=.*[a-z])(?=.*[A-Z])(?=.*d)(?=.*[$@$!#.])[A-Za-zd$@$!%*?&.]{8,20}/').min(8).max(20).required()

  // function navToLogin() {
  //   navigate('/login')
  // };

  let navigate = useNavigate()
  const [errorMessage, setErrorMessage] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  let validationSchema = object({
    userName: string().min(5).max(32).required(),
    email: string().email().required(),
    phone: string().matches(/^(\+201|01|00201)[0-2,5]{1}[0-9]{8}/).required(),
    password: string().matches(/^(?=.*[A-Za-z])(?=.*\d)*([@$!%*#?&])*[A-Za-z\d@$!%*#?&.]{6,32}$/, "password must match the pattern").required(),
    cPass: string().oneOf([ref('password')], "password and re password must be the same").required(),
    DOB: string().required(),
  });

  let registerFormik = useFormik({
    initialValues: {
      userName: '',
      email: '',
      phone: '',
      password: '',
      cPass: '',
      DOB: '',
    },
    validationSchema,
    onSubmit: (values) => {
      setIsLoading(true)
      // console.log(values);
      axios.post(`https://ecommerce-be-sand.vercel.app/auth/signup`, values).then((response) => {
        if (response.status === 201) {
          setIsLoading(false)
          navigate('/signin')
        }
        // console.log(response);
      }).catch((error) => {
        if (error.response) {
          setIsLoading(false)
          setErrorMessage(error.response.data.error)
        }
      })
    }
  })




  return (
    <div className="container my-5">
      <h2 className="text-center mb-5">Registration Form </h2>
      <div className="row g-3 align-items-center justify-content-center">
        <form className="px-4" onSubmit={registerFormik.handleSubmit}>
          <div className="row">
            <div className="col-md-12">
              <div className="mb-3">
                <label htmlFor="userName" className="form-label">Name</label>
                <input onBlur={registerFormik.handleBlur}
                  onChange={registerFormik.handleChange}
                  value={registerFormik.values.userName} type="text" className="form-control" id="userName" name='userName' />
                {registerFormik.errors.userName && registerFormik.touched.userName ? (
                  <div className=" text-red-700 m-1">
                    {registerFormik.errors.userName}
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
          <div className="mb-3">
            <label htmlFor="email" className="form-label">Email address</label>
            <input onBlur={registerFormik.handleBlur}
              value={registerFormik.values.email}
              onChange={registerFormik.handleChange} type="email" className="form-control" id="email" name='email' />
            {registerFormik.errors.email && registerFormik.touched.email ?
              <div className=" py-1 text-red-700 my-2">{registerFormik.errors.email}</div> : ""}
            <div id="emailHelp" className="form-text">We'll never share your email with anyone else.</div>

          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="mb-3">
                <label htmlFor="password" className="form-label">Password</label>
                <input onBlur={registerFormik.handleBlur}
                  value={registerFormik.values.password}
                  onChange={registerFormik.handleChange} type="password" className="form-control" id="password" name='password' />
                {registerFormik.errors.password && registerFormik.touched.password ?
                  <div className=" py-1 text-red-600 my-2">{registerFormik.errors.password}</div> : ""}
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-3">
                <label htmlFor="cPass" className="form-label">Confirm Password</label>
                <input onBlur={registerFormik.handleBlur}
                  value={registerFormik.values.cPass}
                  onChange={registerFormik.handleChange} type="password" className="form-control" id="cPass" name='cPass' />
                {registerFormik.errors.cPass && registerFormik.touched.cPass ?
                  <div className=" py-1 text-red-600 my-2">{registerFormik.errors.cPass}</div> : ""}
              </div>
            </div>
          </div>
          <div className="mb-3">
            <label htmlFor="phone" className="form-label">Phone</label>
            <input onBlur={registerFormik.handleBlur}
              onChange={registerFormik.handleChange}
              value={registerFormik.values.phone} type="text" className="form-control" id="phone" name='phone' />
            {registerFormik.errors.phone && registerFormik.touched.phone ?
              <div className=" py-1 text-red-600 my-2">{registerFormik.errors.phone}</div> : ""}
          </div>
          <div className="mb-3">
            <label htmlFor="DOB" className="form-label">Date of Birth</label>
            <input onBlur={registerFormik.handleBlur}
              onChange={registerFormik.handleChange}
              value={registerFormik.values.DOB} type="date" className="form-control" id="DOB" name='DOB' />
            {registerFormik.errors.DOB && registerFormik.touched.DOB ?
              <div className=" py-1 text-red-600 my-2">{registerFormik.errors.DOB}</div> : ""}
          </div>
          <button disabled={registerFormik.isValid && registerFormik.dirty && !isLoading ? false : true} type="submit" className="btn btn-outline-warning my-2 px-5">{isLoading ? <i className="fas fa-spinner fa-spin"></i> : 'Register'}</button>
        </form>
        <div className="text-center ">Already have account? <Link className="text-warning" to="/login">Login</Link></div>
      </div>
    </div>
  )
}
